import Cookies from 'js-cookie';

export const getAffiliate = () => {
  try {
    const pp = Cookies.get('pp') ? JSON.parse(Cookies.get('pp')) : null;

    if (pp) {
      return {
        provider: 'ParceirosPromo',
        code: pp.pcrid,
      };
    }

    const pap = Cookies.get('pap') ? JSON.parse(Cookies.get('pap')) : null;

    if (pap) {
      return {
        provider: 'PostAffiliatePro',
        code: pap.affiliate,
      };
    }

    return {
      provider: 'None',
    };
  } catch (error) {
    return {};
  }
};
